/**
 * When saving the text based submissions onblur
 * the focused operation if passed if the user is
 * focused on the text input field.
 *
 * If the text field is still in focus and user
 * closes the browser, prevent the user from closing
 * the tab so that onBlur event will run and save the data
 */

import {
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { QuestionSaveOp } from './useQuestionSaveStatus';

const usePreventUnsavedTabClose = () => {
  const statusTrackMap = useRef<Record<string, QuestionSaveOp>>({});

  const cbRef = useRef((e: BeforeUnloadEvent) => {
    // check if map contains 'focused' op and prevent the tab close
    const focused = Object.values(statusTrackMap.current).includes('focused');
    if (focused) {
      e.preventDefault();
    }
  });

  const trackSaveOp = useCallback((op: QuestionSaveOp, qId: number, cId?: number) => {
    const key = cId ? `${qId}.${cId}` : qId.toString();
    const trackmap = statusTrackMap.current;
    trackmap[key] = op;
    statusTrackMap.current = trackmap;
    return trackmap;
  }, []);

  useEffect(() => {
    // load beforeunload event listener on component mount
    // and remove the event when component unmounts
    const onUnload = cbRef.current;
    window.addEventListener('beforeunload', onUnload);
    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, []);

  return trackSaveOp;
};

export default usePreventUnsavedTabClose;
